import React, { Fragment, JSX } from 'react'
import { Skeleton } from '@bbl-digital/snorre-v2'

interface IProps {
  /** Defaults to 5 */
  length?: number
  /* height of the skeleton */
  height?: number
  /** Warries the widths of the skeletons */
  differ?: boolean
}

const SkeletonList: React.FC<IProps> = (props) => {
  const arr: JSX.Element[] = []
  const length = props.length ? props.length : 5

  const getLength = (index: number) => {
    if (index === 0) return '100%'
    if ((index + 1) % 3 === 0) return '90%'
    if ((index + 1) % 4 === 0) return '60%'
    if ((index + 1) % 5 === 0) return '80%'
    return '70%'
  }

  const getHeight = () => (props.height ? `${props.height}px` : undefined)

  for (let i = 0; i < length; i++) {
    arr.push(
      <Skeleton
        key={i}
        height={getHeight()}
        width={props.differ ? getLength(i) : undefined}
      />
    )
  }

  return <Fragment>{arr}</Fragment>
}

export default SkeletonList
